/**
 * Formats a date to "dd MMM, yyyy" format (e.g., "05 Jan, 2026")
 * @param date - Date object, string, or number (timestamp)
 * @returns Formatted date string
 */
export function formatDate(date: Date | string | number): string {
    const d = new Date(date);

    const day = d.getDate().toString().padStart(2, '0');
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = months[d.getMonth()];
    const year = d.getFullYear();

    return `${day} ${month}, ${year}`;
}

/**
 * Formats a date with time to "dd MMM, yyyy HH:mm" format
 * @param date - Date object, string, or number (timestamp)
 * @returns Formatted date and time string
 */
export function formatDateTime(date: Date | string | number): string {
    const d = new Date(date);

    const day = d.getDate().toString().padStart(2, '0');
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = months[d.getMonth()];
    const year = d.getFullYear();
    const hours = d.getHours().toString().padStart(2, '0');
    const minutes = d.getMinutes().toString().padStart(2, '0');

    return `${day} ${month}, ${year} ${hours}:${minutes}`;
}
